export const scenarioStatus = {
  DRAFT: 'DRAFT',
  VALIDATED: 'VALIDATED',
  OFFICIAL: 'OFFICIAL',
  SIMULATION: 'SIMULATION',
  ARCHIVED: 'ARCHIVED'
}
